export function isAxiosError(error) {
    return error instanceof Error && 'isAxiosError' in error;
}
//# sourceMappingURL=is-axios-error.js.map